<template>
  <div class="sidebar">
    <div class="sidebar__logo margin-b-lg padding-t-xs">
      <m4-brand-image v-if="brandImage" :src="brandImage"></m4-brand-image>
      <template v-else-if="brandTitle">
        <m4-icon icon="list-alt"></m4-icon>
        <div class="sidebar__logo__title">
          {{ brandTitle }}
        </div>
      </template>
    </div>
    <m4-sidebar-menu :menu-items="menuItems"></m4-sidebar-menu>
  </div>
</template>

<script>
export default {
  name: "M4Sidebar",
  props: {
    brandImage: String,
    brandTitle: String,
    menuItems: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>
